import { getLocale } from "../runtime";

const sv_skcountryenglish = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Slovakia`
};

const skcountryenglish = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_skcountryenglish(inputs)
	return "skCountryEnglish";
};

export { skcountryenglish as "skCountryEnglish" };